export default __webpack_public_path__ + "static/media/cancelIcon.356ce51d.svg";